module.exports = __webpack_public_path__ + "static/img/urlmap.317afb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/urlmap.png
// module id = /3DI
// module chunks = 0